import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Box — a generic block container. Renders a plain <div> with className forwarding.
 * Use Stack when you need vertical flex layout, CenterBox when you need centered content.
 * Box is the fallback for structural containers that carry no layout semantics.
 *
 * @atomic-tier Atom
 * @category Layout
 */

export type BoxProps = React.HTMLAttributes<HTMLDivElement>

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={cn(className)} {...props}>
      {children}
    </div>
  ),
)
Box.displayName = "Box"

export { Box }
